/**
 * @generated SignedSource<<1a7ef5e81c74f460efa59367ac87d8a6>>
 * @relayHash e044f4f123cab97e4a176db41b7362e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80bca32e39cc37fd5868fcb75478bf4c17e05ff8f14ec377a536e61312c1e09f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessAttachmentsQuery } from './src_jiraBusinessAttachmentsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "80bca32e39cc37fd5868fcb75478bf4c17e05ff8f14ec377a536e61312c1e09f",
    "metadata": {},
    "name": "src_jiraBusinessAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
